import './preact/store';
import './preact/app-renderer';

import '../../node_modules/bootstrap/js/dist/dropdown';